var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delta",class:_vm.delta.tone},[(_vm.delta.plain)?[_vm._v(_vm._s(_vm.delta.main))]:_c('b',{attrs:{"title":"Относительное изменение к датам в блоке «Сравниваем»"}},[_vm._v(_vm._s(_vm.delta.main))]),(_vm.delta.extra)?_c('span',{attrs:{"title":_vm.delta.extraTitle || null}},[_vm._v(_vm._s(_vm.delta.extra))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }